<template>
    <div
        v-if="store.open"
        class="toast"
        :class="[store.position]"
        :style="store.style"
    >
        {{ store.message }}
    </div>
</template>

<script>
import Vue from 'vue'

const defaultStore = {
    open: false,
    message: '',
    position: 'center',
    style: {},
};

const store = Vue.observable({
    ...defaultStore
});

export default {
    data() {
        return {
            store
        };
    },
}

function hideToastWithoutClearTimeout() {
    store.open = false;
    store.position = defaultStore.position;
    store.style = defaultStore.style;
    tId = -1;
}

/**
 * 显示toast
 * @param {String} message 显示的内容
 * @param {Object} config
 * @param {Number} config.duration 持续时长，单位毫秒
 * @param {String} config.position 显示位置，取值：top, center(默认), bottom
 * @param {Object} config.style
 */
let tId;
export function showToast(message, { duration = 1500, position, style } = {}) {
    if (message == null) {
        throw new TypeError('message不能为空');
    }

    store.open = true;
    store.message = message;
    store.position = position ?? defaultStore.position;
    store.style = style ??  defaultStore.style;
    clearTimeout(tId);
    tId = setTimeout(hideToastWithoutClearTimeout, duration);
}

/**
 * 隐藏
 */
export function hideToast() {
    clearTimeout(tId);
    hideToastWithoutClearTimeout();
}
</script>

<style lang="scss" scoped>
.toast {
    position: fixed;
    z-index: 9999;
    left: 50%;
    transform: translateX(-50%);
	padding: .453333rem /* 34/75 */ .533333rem /* 40/75 */;
    text-align: center;
    font-size: .426667rem /* 32/75 */;
    background: rgba(0,0,0,0.7);
    color: #fff;
    border-radius: 9999px;
	min-width: 6.72rem /* 504/75 */;
	line-height: normal;
	white-space: nowrap;
    &.top {
        
    }

    &.center {
        top: 50%;
        transform: translate(-50%, -50%);
    }

    &.bottom {
        bottom: 1.6rem /* 120/75 */;
    }
}
</style>
